import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React from 'react';
import PropTypes from 'prop-types';
import { normalizeHref, uuid, validate, mergeStyles } from 'wix-rich-content-common';
import pluginGallerySchema from 'wix-rich-content-common/dist/statics/schemas/plugin-gallery.schema.json';
import { debounce, isEqual } from 'lodash';
import { g as getAbsoluteUrl, s as styles, r as resizeMediaUrl, e as expand } from './expand.js';
import { s as sampleItems, i as isHorizontalLayout, G as GALLERY_TYPE, g as getFixedStyles, F as FROM_LAYOUT_NUMBER, D as DEFAULTS } from './viewer-loadable2.js';
import classnames from 'classnames';
import { GALLERY_CONSTS, ProGallery } from 'pro-gallery';
import 'image-client-api/dist/imageClientSDK';
import '@loadable/component';
import 'ricos-schema';
import 'ricos-types';

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var convertItemData = function convertItemData(_ref) {
  var items = _ref.items,
    anchorTarget = _ref.anchorTarget,
    relValue = _ref.relValue;
  return items.map(function (item, index) {
    var metadata = item.metadata,
      metaData = item.metaData;
    if (metaData && item.mediaUrl) {
      return item;
    }
    var convertedData = {
      mediaUrl: item.url,
      metaData: {
        link: {
          type: "none",
          target: "_blank"
        }
      },
      directLink: {}
    };
    if (metadata) {
      convertedData.metaData = __spreadProps$1(__spreadValues$1({}, metadata), {
        link: {
          type: "none",
          target: "_blank"
        }
      });
      if (item.metadata.type === "video") {
        convertedData.metaData.link = {
          target: "_blank",
          rel: "noopener",
          url: normalizeHref(item.url || "")
        };
        var _ref2 = convertedData.metaData.poster || {},
          pathname = _ref2.pathname,
          _ref2$thumbnail = _ref2.thumbnail;
        _ref2$thumbnail = _ref2$thumbnail === void 0 ? {} : _ref2$thumbnail;
        var thumbPathname = _ref2$thumbnail.pathname,
          width = _ref2$thumbnail.width,
          height = _ref2$thumbnail.height;
        if (pathname && thumbPathname) {
          convertedData.metaData.poster = {
            url: getAbsoluteUrl(thumbPathname, "image"),
            width: width,
            height: height
          };
        } else if (typeof convertedData.metaData.poster === "string") {
          convertedData.metaData.poster = {
            url: convertedData.metaData.poster,
            width: convertedData.metaData.width,
            height: convertedData.metaData.height
          };
        }
      }
      convertedData.metaData.alt = metadata.altText;
      if (item.metadata.link) {
        convertedData.metaData.link = {
          type: "wix",
          target: item.metadata.link.target || anchorTarget || "_self",
          data: {
            type: "ExternalLink",
            target: item.metadata.link.target || anchorTarget || "_self",
            rel: item.metadata.link.rel || relValue || "noopener",
            url: normalizeHref(item.metadata.link.url || "")
          }
        };
        convertedData.directLink = {
          url: normalizeHref(item.metadata.link.url || ""),
          target: item.metadata.link.target || anchorTarget || "_self",
          rel: item.metadata.link.rel || relValue || "noopener"
        };
      }
    }
    uuid();
    return __spreadProps$1(__spreadValues$1(__spreadProps$1(__spreadValues$1({}, item), {
      metadata: void 0
    }), convertedData), {
      // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - it gives console errors and might also break the video controls behavoiur.
      // TODO: remove uuid when gallery fixes the issue \ release version 4.
      itemId: uuid() + "_" + index.toString(),
      hash: item.url + "_" + index.toString()
    });
  });
};

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var GALLERY_EVENTS = GALLERY_CONSTS.events;
var GalleryViewer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GalleryViewer, _React$Component);
  function GalleryViewer(props) {
    var _this;
    validate(props.componentData, pluginGallerySchema);
    _this = _React$Component.call(this, props) || this;
    __publicField(_assertThisInitialized(_this), "shouldUpdateDimensions", function (prevComponentData) {
      var _a, _b;
      var _ref = (_a = prevComponentData.styles) != null ? _a : {},
        prevGalleryLayout = _ref.galleryLayout;
      var _ref2 = (_b = _this.props.componentData.styles) != null ? _b : {},
        currentGalleryLayout = _ref2.galleryLayout;
      if (currentGalleryLayout !== prevGalleryLayout) {
        return true;
      }
      if (!isEqual(prevComponentData.config, _this.props.componentData.config)) {
        return true;
      }
    });
    __publicField(_assertThisInitialized(_this), "shouldConsiderThumbnailSize", function () {
      var _this$getComponentDat = _this.getComponentDataStyles(),
        galleryLayout = _this$getComponentDat.galleryLayout,
        galleryThumbnailsAlignment = _this$getComponentDat.galleryThumbnailsAlignment;
      return _this.props.isMobile && galleryLayout === 3 && ["top", "bottom"].includes(galleryThumbnailsAlignment);
    });
    __publicField(_assertThisInitialized(_this), "getGalleryHeight", function (width) {
      var height = 305;
      if (width) {
        height = _this.shouldConsiderThumbnailSize() ? Math.floor(width * 2 / 3) + 95 : Math.floor(width * 3 / 4);
      }
      return height;
    });
    __publicField(_assertThisInitialized(_this), "getDimensions", function () {
      var width = Math.floor(_this.containerRef.current.getBoundingClientRect().width);
      var height = _this.getGalleryHeight(width);
      return {
        width: width,
        height: height
      };
    });
    __publicField(_assertThisInitialized(_this), "updateDimensions", debounce(function () {
      var _a, _b;
      var _this$getDimensions = _this.getDimensions(),
        width = _this$getDimensions.width,
        height = _this$getDimensions.height;
      if (width !== ((_a = _this.state.size) == null ? void 0 : _a.width) || height !== ((_b = _this.state.size) == null ? void 0 : _b.height)) {
        _this.setState({
          size: {
            width: width,
            height: height
          }
        });
      }
    }, 100));
    __publicField(_assertThisInitialized(_this), "handleGalleryEvents", function (name, data) {
      var styleParams = _this.getComponentDataStyles();
      switch (name) {
        case GALLERY_EVENTS.GALLERY_CHANGE:
          if (_this.containerRef.current) {
            if (!isHorizontalLayout(styleParams)) {
              _this.containerRef.current.style.height = data.layoutHeight + "px";
            } else {
              _this.containerRef.current.style.height = "auto";
            }
          }
          break;
        case GALLERY_EVENTS.ITEM_ACTION_TRIGGERED:
          data.type !== "video" && !data.linkData.url && _this.hasExpand() && _this.handleExpand(data);
          break;
      }
    });
    __publicField(_assertThisInitialized(_this), "handleExpand", function (data) {
      var _a;
      var _this$props = _this.props,
        onExpand = _this$props.settings.onExpand,
        _this$props$helpers = _this$props.helpers,
        helpers = _this$props$helpers === void 0 ? {} : _this$props$helpers;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, GALLERY_TYPE, "Click", "expand_gallery");
      _this.hasExpand() && onExpand(_this.props.blockKey, data.idx);
    });
    __publicField(_assertThisInitialized(_this), "renderExpandIcon", function (itemProps) {
      return /* @__PURE__ */React.createElement("div", {
        className: _this.styles.expandContainer
      }, /* @__PURE__ */React.createElement(expand, {
        className: _this.styles.expandIcon,
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
          _this.handleExpand(itemProps);
        }
      }));
    });
    __publicField(_assertThisInitialized(_this), "hasExpand", function () {
      var _this$props2 = _this.props,
        componentData = _this$props2.componentData,
        settings = _this$props2.settings;
      var disableExpand = false;
      if (componentData.disableExpand !== void 0) {
        disableExpand = componentData.disableExpand;
      } else if (settings.disableExpand !== void 0) {
        disableExpand = settings.disableExpand;
      }
      return !disableExpand && settings.onExpand;
    });
    __publicField(_assertThisInitialized(_this), "renderTitle", function (title) {
      return title ? /* @__PURE__ */React.createElement("div", {
        className: styles.imageTitleContainer
      }, /* @__PURE__ */React.createElement("div", {
        className: _this.styles.imageTitle
      }, title)) : null;
    });
    __publicField(_assertThisInitialized(_this), "hoverElement", function (itemProps) {
      var _a, _b;
      var isClickable = _this.hasExpand() || itemProps.link;
      var itemOverlayStyles = classnames(_this.styles.itemOverlay, isClickable && _this.styles.clickableItem);
      return /* @__PURE__ */React.createElement("div", {
        className: itemOverlayStyles
      }, _this.hasExpand() && _this.renderExpandIcon(itemProps), _this.renderTitle(itemProps.title, "HOVER"), (_b = (_a = _this.props).itemOverlayElement) == null ? void 0 : _b.call(_a, itemProps));
    });
    __publicField(_assertThisInitialized(_this), "getStyleParams", function () {
      var _this$props3 = _this.props,
        disableDownload = _this$props3.componentData.disableDownload,
        isMobile = _this$props3.isMobile;
      var styleParams = _this.getComponentDataStyles();
      var calculatedStyles = __spreadValues(__spreadProps(__spreadValues({}, getFixedStyles(FROM_LAYOUT_NUMBER[styleParams.galleryLayout])), {
        allowContextMenu: !disableDownload,
        showArrows: isHorizontalLayout(styleParams)
      }), styleParams);
      if (isMobile) {
        if (calculatedStyles.m_numberOfImagesPerRow) {
          calculatedStyles.numberOfImagesPerRow = calculatedStyles.m_numberOfImagesPerRow;
        }
        if (isHorizontalLayout(calculatedStyles)) {
          calculatedStyles.arrowsSize = 20;
          !styleParams.imageMargin && (calculatedStyles.imageMargin = 0);
          if (calculatedStyles.galleryLayout === 3) {
            calculatedStyles.thumbnailSize = 90;
          }
        }
      }
      calculatedStyles.oneRow && (calculatedStyles.scrollDirection = GALLERY_CONSTS.scrollDirection.HORIZONTAL);
      calculatedStyles.thumbnailSpacings && (calculatedStyles.thumbnailSpacings /= 2);
      return calculatedStyles;
    });
    __publicField(_assertThisInitialized(_this), "handleContextMenu", function (e) {
      var _this$props$component = _this.props.componentData.disableDownload,
        disableDownload = _this$props$component === void 0 ? false : _this$props$component;
      return disableDownload && e.preventDefault();
    });
    _this.domId = _this.props.blockKey || "v-" + _this.props.entityIndex;
    _this.containerRef = /*#__PURE__*/React.createRef();
    _this.state = {
      items: []
    };
    return _this;
  }
  var _proto = GalleryViewer.prototype;
  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.setState({
      size: this.getDimensions()
    });
    this.initUpdateDimensionsForDomChanges();
  };
  _proto.initUpdateDimensionsForDomChanges = function initUpdateDimensionsForDomChanges() {
    var _this2 = this;
    var _a;
    var _ref3 = (_a = this.props) == null ? void 0 : _a.settings,
      scrollingElement = _ref3.scrollingElement;
    if (!scrollingElement) {
      console.error("Please fix the gallery config of Rich Content Editor.\n        A scrollingElement needs to be provided. Without it the gallery will not work correctly");
      scrollingElement = document.body;
    }
    var contentElement = typeof scrollingElement === "function" ? scrollingElement() : scrollingElement;
    if ((contentElement == null ? void 0 : contentElement.nodeType) !== 1) {
      contentElement = document.body;
    }
    if (contentElement) {
      this.observer = new MutationObserver(function () {
        if (contentElement.clientHeight !== _this2.oldContentElementHeight) {
          _this2.oldContentElementHeight = contentElement.clientHeight;
          _this2.updateDimensions();
        }
      });
      this.observer.observe(contentElement, {
        attributes: true,
        childList: true,
        subtree: true
      });
    } else {
      console.warn("can't find content container to listen for changes to update gallery");
    }
  };
  GalleryViewer.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
    var contentItems = props.componentData.items,
      anchorTarget = props.anchorTarget,
      relValue = props.relValue;
    var items = contentItems || [];
    items = items.filter(function (item) {
      return !item.error;
    });
    items = items.length > 0 ? convertItemData({
      items: items,
      anchorTarget: anchorTarget,
      relValue: relValue
    }) : sampleItems;
    return {
      items: items
    };
  };
  _proto.getComponentDataStyles = function getComponentDataStyles() {
    var componentData = this.props.componentData;
    return componentData.styles || __spreadValues({}, DEFAULTS);
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    var _this$props$component2 = this.props.componentData,
      currentStyles = _this$props$component2.styles,
      currentItems = _this$props$component2.items,
      currentConfig = _this$props$component2.config;
    var _nextProps$componentD = nextProps.componentData,
      nextStyles = _nextProps$componentD.styles,
      nextItems = _nextProps$componentD.items,
      nextConfig = _nextProps$componentD.config;
    return !isEqual(nextState.size, this.state.size) || !isEqual(nextStyles, currentStyles) || !isEqual(nextItems, currentItems) || !isEqual(nextConfig, currentConfig);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.shouldUpdateDimensions(prevProps.componentData)) {
      this.updateDimensions();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.observer.disconnect();
    window.removeEventListener("resize", this.updateDimensions);
    this.updateDimensions.cancel();
  };
  _proto.render = function render() {
    var _this$props4 = this.props,
      theme = _this$props4.theme,
      settings = _this$props4.settings,
      seoMode = _this$props4.seoMode;
    this.styles = this.styles || mergeStyles({
      styles: styles,
      theme: theme
    });
    var _a = settings,
      scrollingElement = _a.scrollingElement,
      gallerySettings = __objRest(_a, ["scrollingElement"]);
    var _this$state = this.state,
      size = _this$state.size,
      items = _this$state.items;
    var styleParams = this.getStyleParams();
    var viewMode = seoMode ? GALLERY_CONSTS.viewMode.SEO : void 0;
    return /* @__PURE__ */React.createElement("div", {
      ref: this.containerRef,
      className: this.styles.gallery_container,
      "data-hook": "galleryViewer",
      role: "none",
      onContextMenu: this.handleContextMenu
    }, (size == null ? void 0 : size.width) ? /* @__PURE__ */React.createElement(ProGallery, {
      domId: this.domId,
      id: this.domId,
      allowSSR: !!seoMode,
      items: items,
      options: styleParams,
      container: size,
      settings: gallerySettings,
      scrollingElement: typeof scrollingElement === "function" ? scrollingElement() : scrollingElement,
      eventsListener: this.handleGalleryEvents,
      createMediaUrl: resizeMediaUrl,
      viewMode: viewMode,
      customComponents: {
        customHoverRenderer: this.hoverElement
      },
      totalItemsCount: items.length
    }) : null);
  };
  return GalleryViewer;
}(React.Component);
GalleryViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  blockKey: PropTypes.string,
  entityIndex: PropTypes.number,
  settings: PropTypes.object,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  helpers: PropTypes.object.isRequired,
  anchorTarget: PropTypes.string.isRequired,
  relValue: PropTypes.string.isRequired,
  seoMode: PropTypes.bool,
  itemOverlayElement: PropTypes.elementType
};

export { GalleryViewer as default };

import 'wix-rich-content-plugin-gallery/dist/loadable/viewer/es/styles.viewer.min.global.css'